/**
 * @file constants/homeConstants.js
 * @description HomePage에 표시되는 정적 콘텐츠 데이터를 관리합니다.
 * 히어로 슬라이드, 제조 프로세스 흐름, Lot 추적 항목, 운영 지원 단계를 정의합니다.
 */

import {
  Boxes,
  ChartColumn,
  ClipboardList,
  FileText,
  FlaskConical,
  Leaf,
  PackageCheck,
  Settings,
  ShieldCheck,
  Truck,
  Warehouse,
} from 'lucide-react';
import { homepage1, homepage2, homepage3, homepage4 } from '../assets';

/* ── 메인 히어로 슬라이드 ── */
export const heroSlides = [
  {
    id: 'hero-main',
    image: homepage1,
    eyebrow: 'Smart Manufacturing for Regulated Industry',
    // [비즈니스] 메인 슬라이드는 브랜드 헤드라인만 노출하고 제품 탐색·문의 CTA로 전환을 유도
    line1: '제약·화장품 산업의 스마트 제조,',
    description: '품질관리, 제조실행, 창고관리를 하나로 연결해 현장 중심 운영 체계를 구현합니다.',
  },
  {
    id: 'hero-mes',
    image: homepage2,
    eyebrow: 'Manufacturing Execution System',
    line1: '현장 중심 MES로 생산·품질·이력 관리를,',
    description: '실시간 모니터링과 표준화된 데이터 기반 의사결정으로 생산성과 규제 대응력을 동시에 강화합니다.',
    href: '/solution/mes.html',
    ctaLabel: 'MES 자세히 보기',
  },
  {
    id: 'hero-rws',
    image: homepage3,
    eyebrow: 'Raw Material Weighing System',
    line1: '정밀 칭량부터 GMP 전자기록까지,',
    description: '저울·바코드·Lot 번호를 배치 지시와 실시간 연동해 수작업 오류를 원천 차단하고,\n식약처·FDA 감사에 즉시 대응 가능한 전자 칭량 기록을 자동 생성합니다.',
    href: '/solution/rws.html',
    ctaLabel: 'RWS 자세히 보기',
  },
  {
    id: 'hero-wms',
    image: homepage4,
    eyebrow: 'Warehouse Management System',
    line1: 'Lot 추적부터 실시간 재고 관리까지,',
    description: 'FIFO·FEFO 기반 입출고 통제와 현장 PDA 연동으로 제약 창고의 유효기한 초과·오출하를 방지하고 완전한 재고 추적성을 확보합니다.',
    href: '/solution/wms.html',
    ctaLabel: 'WMS 자세히 보기',
  },
];

/* ── 제약·화장품 제조 프로세스 흐름 (Why Saehim 카드) ── */
export const pharmaFlow = [
  { label: '원료 칭량', Icon: Leaf },
  { label: '제조기록', Icon: FileText },
  { label: '생산', Icon: Settings },
  { label: '입출고', Icon: Warehouse },
  { label: '완제품', Icon: PackageCheck },
];

/* ── Lot 추적 단계 (Why Saehim 카드) ── */
export const traceItems = [
  { label: '원료 투입', Icon: FlaskConical },
  { label: '생산 Batch', Icon: ClipboardList },
  { label: '완제품 생산', Icon: Boxes },
  { label: '출고', Icon: Truck },
];

/* ── 구축 이후 운영 지원 단계 (Why Saehim 카드) ── */
export const supportFlow = [
  { label: '이슈 접수', Icon: FileText },
  { label: '분석 및 대응', Icon: ChartColumn },
  { label: '개선 반영', Icon: Settings },
  { label: '사후 관리', Icon: ShieldCheck },
];
